import { Component } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';

@Component({
  name: 'bpc-display-field-percent',
  components: {},
})
export default class DisplayFieldPercent extends mixins(AbstractDisplayField) {
  get formatted() {
    let value = this.value;
    if (!value && this.emptyIfNull) {
      return '';
    }

    if (!value && this.zeroIfNull) {
      value = '0';
    }

    if (typeof value === 'string') {
      value = value.replace(',', '.');
    }

    // Number of decimals
    value = value + '';
    let decimalsLength = 0;
    const splitValue = value.split('.');
    if (splitValue[1]) {
      decimalsLength = splitValue[1].length;
    }

    return (
      parseFloat(value)
        .toFixed(Math.max(2, decimalsLength))
        .replace('.', ',') + ' %'
    );
  }

  get valueLabel(): string {
    const item = this.fieldConfig.valueToLabel?.find(item => item.value === this.value);
    return item?.label || this.value;
  }
}
